import {USER_VERIFY_REQUEST, USER_VERIFY_FAILURE, USER_VERIFY_SUCCESS} from './constants';

export function verifyUser (data) {
    return {
        type: USER_VERIFY_REQUEST,
        data
    }
}

export function verifyUserSuccess (data) {
    return {
        type: USER_VERIFY_SUCCESS,
        data
    }
}

export function verifyUserFailure (data) {
    return {
        type: USER_VERIFY_FAILURE,
        data
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/VerifyUser/actions.js